'use client';

import React from 'react';

import Link from 'next/link';

import { withEventScope } from '@repo/event-processor';
import { Tag } from '@repo/ui-kit/components/core/Tag';
import { H1 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn, FlexRow } from 'styles/layouts';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { RelatedLinksProps } from './types';

const RelatedLinks: React.FC<RelatedLinksProps> = ({ title, links }) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        <FlexColumn gap="48px">
          <H1 bold as="h2">
            {title}
          </H1>
          <FlexRow flexWrap="wrap" gap="12px">
            {links.map((link, index) => (
              <Link key={index} href={link.url}>
                <Tag>{link.label}</Tag>
              </Link>
            ))}
          </FlexRow>
        </FlexColumn>
      </ComponentContainer>
    </ComponentWrapper>
  );
};

export default withEventScope(RelatedLinks, { module: 'relatedLinks' });
